import { format, parseISO, isValid } from 'date-fns'

export const formatDate = (e) => {
  if (e !== null) {
    let data = e.split('-')
    return data[2] + '/' + data[1] + '/' + data[0]
  }
  return ''
}

export const moeda = (valor) => {
  const v = valor ? parseFloat(valor) : 0
  return v.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
}

export const ehInteiro = (num) => {
  if (Number.isInteger(num)) {
    return parseInt(num)
  } else {
    return parseFloat(num)
  }
}

export const formataDataCompleta = (data) => {
  return !data ? 'Sem data' : format(parseISO(data), 'dd/MM/yyyy HH:mm:ss')
}

export const formataDataSemHora = (data) => {
  return !data ? 'Sem data' : format(parseISO(data), 'dd/MM/yyyy')
}

export const isData = (data) => {
  return isValid(parseISO(data))
}

export const debounce = (func, wait) => {
  let timeout
  return function (...args) {
    clearTimeout(timeout)
    timeout = setTimeout(() => {
      func.apply(this, args)
    }, wait)
  }
}

export const redirecionarWhats = (telefone) => {
  if (telefone) {
    let numero = telefone.replace(/[\(\)\.\s-]+/g, '')
    let mensagem = `Olá, encontrei seu contato através do Menucheff Delivery.`
    let link = `https://api.whatsapp.com/send?phone=55${numero}&text=${mensagem}`
    window.location.href = link
  }
}

export const redirecionarTelefone = (telefone) => {
  if (telefone) {
    let numero = telefone.replace(/[\(\)\.\s-]+/g, '')
    window.open(`tel:${numero}`)
  }
}
